import React from 'react';
import { Route, Switch } from 'react-router';

import LoginPage from '../login/LoginPageContainer';
import SignupPage from '../login/SignupPageContainer';
import WelcomePage from '../welcome/WelcomePage';
import ReservePage from '../reserve/ReservePageContainer';
import CreatePage from '../create/CreatePageContainer';
import SendPage from '../send/SendPageContainer';
import SearchPage from '../search/SearchPageContainer';

const mainRoutes = (
  <Switch>
    <Route exact path="/" component={WelcomePage} />
    <Route path="/welcome" component={WelcomePage} />
    <Route path="/login" component={LoginPage} />
    <Route path="/signup" component={SignupPage} />
    <Route path="/reserve" component={ReservePage} />
    <Route path="/create" component={CreatePage} />
    <Route path="/send" component={SendPage} />
    <Route path="/search" component={SearchPage} />
  </Switch>
)

export default mainRoutes;
